import React, { useEffect, useState } from "react";
import { useParams, useLocation } from "react-router-dom";
import blogData from "./data";
import Templates from "./TemplateData";
import ContentBelow from "../../components/ContentBelow";
import Head from "../../components/Head";
import background from "../../images/BlogHeadingBackGround.jpg";
import { Link } from "react-router-dom";
import classes from "../../components/Article.module.css";
import BlogTreeView from "../../components/BlogTreeView";
import Template1 from "./Templates/Template1";
import Template2 from "./Templates/Template2";
import Template3 from "./Templates/Template3";
import Template4 from "./Templates/Template4";

export default function Article() {
  const { name } = useParams();

  // Helper: convert title to slug for URL matching
  const slugify = (title) => title.replace(/\s+/g, "-").toLowerCase();

  // Find the blog post that matches the URL slug
  //const post = blogData.find((p) => slugify(p.title) === name);
  const post =
    Templates.find((p) => slugify(p.title) === name) ||
    blogData.find((p) => slugify(p.title) === name);
  if (!post) {
    return <p>No article found for "{name}"</p>;
  }
  const allPost = [...blogData, ...Templates].sort((a, b) =>
    a.title.localeCompare(b.title),
  );
  const currentIndex = allPost.findIndex((p) => slugify(p.title) === name);
  if (currentIndex === -1) {
    return <p>No article found</p>;
  }

  const prevPost = currentIndex > 0 ? allPost[currentIndex - 1] : null;
  const nextPost =
    currentIndex < allPost.length - 1 ? allPost[currentIndex + 1] : null;

  function TemplateReadLayout({ children }) {
    return (
      <>
        <Head imageUrl={background}>
          <h2 className="heading_space">Our Blogs</h2>
        </Head>
        <ContentBelow>
          <div
            className={`container mt-5 mx-auto d-flex justify-content-center flex-column ${classes.article}`}
          >
            <div className="row align-items-start">
              <div className="col-lg-5">
                {/* Author Info */}
                <div className="d-flex align-items-center mb-3">
                  <div
                    className="rounded-circle bg-primary text-white d-flex align-items-center justify-content-center"
                    style={{ width: "40px", height: "40px" }}
                  >
                    {post.author.charAt(0)}
                  </div>
                  <div className="ms-2 text-muted small">
                    <div className="fw-semibold">{post.author}</div>
                    <div>
                      {post.date} • {post.readTime}
                    </div>
                  </div>
                </div>
                {/* Title */}

                {/* Image */}
                {post.imgSrc ? (
                  <img
                    src={post.imgSrc}
                    alt={post.title}
                    className="img-fluid rounded mb-4"
                  />
                ) : null}
                <div className="col-md-7 col-lg-8 col-sm-5 mx-0">
                  <BlogTreeView />
                </div>
              </div>
              <div className="col-lg-6 d-flex align-items-start">
                {children}
              </div>
            </div>
            {/* Navigation Buttons */}
            <div className="d-flex justify-content-between">
              {prevPost ? (
                <Link
                  to={`/Article/${slugify(prevPost.title)}`}
                  className="btn btn-outline-secondary"
                >
                  ← Previous
                </Link>
              ) : (
                <span />
              )}

              {nextPost ? (
                <Link
                  to={`/Article/${slugify(nextPost.title)}`}
                  className="btn btn-outline-secondary"
                >
                  Next →
                </Link>
              ) : null}
            </div>
          </div>
        </ContentBelow>
      </>
    );
  }
  function OldLayout({ posts }) {
    return (
      <>
        <div
          className={`container mt-5 mx-auto d-flex justify-content-center flex-column ${classes.article}`}
        >
          <div className="row align-items-start">
            {/* Content */}
            <div
              className=""
              style={{
                fontSize: "clamp(12px,2vw, 14px)",
              }}
            >
              {posts.h1 ? <h2 className="h2">{post.h1}</h2> : null}
              {posts.p1 ? <p> {posts.p1}</p> : null}
              {posts.p2 ? <p> {posts.p2}</p> : null}
              {posts.p3 ? <p> {posts.p3}</p> : null}
              {posts.p4 ? <p> {posts.p4}</p> : null}
              {posts.sub1h1 ? <h3>{posts.sub1h1}</h3> : null}
              {posts.sub1P1 ? <p> {posts.sub1P1}</p> : null}
              {posts.sub1UL1 ? (
                <ul>
                  {posts.sub1UL1.map((item, i) => (
                    <li key={i}>{item.a}</li>
                  ))}
                </ul>
              ) : null}
              {posts.sub1P2 ? <p> {posts.sub1P2}</p> : null}
              {posts.sub1P3 ? <p> {posts.sub1P3}</p> : null}
              {posts.sub2h1 ? <h3>{posts.sub2h1}</h3> : null}

              {posts.sub2P1 ? <p> {posts.sub2P1}</p> : null}
              {posts.sub2P1UL ? (
                <ul>
                  {posts.sub2P1UL.map((item, i) => (
                    <li key={i}>{item}</li>
                  ))}
                </ul>
              ) : null}
              {posts.sub2P2 ? <p> {posts.sub2P2}</p> : null}
              {posts.sub2UL1 ? (
                <ul>
                  {posts.sub2UL1.map((item, index) => (
                    <li key={index}>
                      <strong>{item.q}</strong> {item.a}
                    </li>
                  ))}
                </ul>
              ) : null}

              {posts.sub2P3 ? <p> {posts.sub2P3}</p> : null}

              <h3>{posts.sub3h1}</h3>
              {posts.sub3P ? <p>{posts.sub3P}</p> : null}
              {posts.sub3UL1 ? (
                <ul>
                  {posts.sub3UL1.map((item, i) => (
                    <li key={i}>{item.q}</li>
                  ))}
                </ul>
              ) : null}

              {posts.sub3UL2 ? (
                <ul>
                  {posts.sub3UL2.map((item, index) => (
                    <li key={index}>
                      <strong>{item.q}</strong> {item.a}
                    </li>
                  ))}
                </ul>
              ) : null}

              <p>{posts.sub3P1}</p>
              <p>{posts.sub3P2}</p>

              <h3>{posts.sub4h1}</h3>
              {posts.sub4P1 ? <p> {posts.sub4P1}</p> : null}

              {posts.sub4UL1 ? (
                <ul>
                  {posts.sub4UL1.map((item, i) => (
                    <li key={i}>{item}</li>
                  ))}
                </ul>
              ) : null}

              <p>{posts.sub4p2}</p>
              <h3>{posts.sub5h1}</h3>
              <p>{posts.sub5P1}</p>
              {posts.sub5UL1 ? (
                <ul>
                  {post.sub5UL1.map((item, i) => (
                    <li key={i}>
                      <strong>{item.q}</strong> {item.a}
                    </li>
                  ))}
                </ul>
              ) : null}

              <p>{posts.sub5P2}</p>
              {posts.exrenalLink ? (
                <>
                  <div className={classes.references}>
                    <h5>References:</h5>
                    <p>{posts.SubHeading} . [online] Available at: </p>
                    <p> {posts.exrenalLink}</p>
                  </div>
                </>
              ) : null}
              {/* <Link
                  to={post.exrenalLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-primary rounded-pill px-4 align-self-start"
                >
                  Read more
                </Link> */}
            </div>
          </div>
        </div>
      </>
    );
  }

  switch (post.template) {
    case "Template1":
      return (
        <>
          <TemplateReadLayout
            children={
              <>
                <Template1 data={post} />
              </>
            }
          />
        </>
      );
    case "Template2":
      return (
        <TemplateReadLayout
          children={
            <>
              <Template2 data={post} />
            </>
          }
        />
      );
    case "Template3":
      return (
        <TemplateReadLayout
          children={
            <>
              <Template3 data={post} />
            </>
          }
        />
      );
    case "Template4":
      return (
        <TemplateReadLayout
          children={
            <>
              <Template4 data={post} />
            </>
          }
        />
      );
    default:
      // ✅ Default to oldLayout when no template is found
      const fallbackPost = blogData.find((item) => item.title === post.title);
      return (
        <TemplateReadLayout
          children={
            <>
              <OldLayout posts={fallbackPost || post} />
            </>
          }
        ></TemplateReadLayout>
      );
  }
}
